"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var FileTypeDAT = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_FileTypeDAT_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 15,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.091 11.116.134.716h-.445l.131-.72.028-.16a3.75 3.75 0 0 0 .036-.188l.028-.18.024.176.032.188c.014.061.024.117.032.168ZM10.243 12.284a.473.473 0 0 1-.44.24h-.152V10.62h.176c.125 0 .23.032.312.096a.568.568 0 0 1 .184.3c.043.136.064.312.064.528 0 .333-.048.58-.144.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14h-.17A3.001 3.001 0 0 1 12 16H4a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h5.517a2 2 0 0 1 1.4.571L14.4 3.983a2 2 0 0 1 .6 1.429V9a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1ZM2 13V3a2 2 0 0 1 2-2h5.215v3.143a1.5 1.5 0 0 0 1.5 1.5H14V9H8a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5.732A2 2 0 0 1 12 15H4a2 2 0 0 1-2-2Zm11.644-8.357-3.427-3.357-.002-.002v2.859a.5.5 0 0 0 .5.5h2.929ZM11.039 13l.588-2.868h.732l.6 2.868h-.516l-.13-.7h-.618l-.128.7h-.528Zm-1.9-2.856V13h.696c.235 0 .432-.056.592-.168a1.05 1.05 0 0 0 .364-.5c.085-.221.128-.492.128-.812 0-.299-.04-.55-.12-.752a.948.948 0 0 0-.356-.464.977.977 0 0 0-.568-.16H9.14Zm-1.356 2.82c.053.053.125.08.216.08.09 0 .161-.027.212-.08a.328.328 0 0 0 .08-.236c0-.107-.025-.185-.076-.236-.05-.053-.123-.08-.216-.08-.096 0-.17.028-.22.084-.05.053-.076.13-.076.232 0 .101.027.18.08.236Zm5.96-2.344V13h.512v-2.38h.644v-.476h-1.8v.476h.644Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_FileTypeDAT_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = FileTypeDAT;
exports["default"] = _default;